import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import ui from './ui';
import {
  CONFIGURATION_DETAIL_FETCH_SUCCESS,
  CONFIGURATION_UPDATE_SUCCESS,
  CONFIGURATIONS_FETCH_FAILURE,
  CONFIGURATIONS_FETCH_SUCCESS,
  CONFIGURATIONS_FETCH,
  PAYMENT_METHOD_CATEGORIES_FETCH_SUCCESS,
  OUTLET_FETCH,
  OUTLET_FETCH_FAILURE,
  OUTLET_FETCH_SUCCESS,
  CREATE_CONFIGURATION_FAILURE,
  CONFIGURATION_UPDATE_FAILURE,
  CONFIGURATION_DETAIL_FETCH,
  CREATE_CONFIGURATION,
  CONFIGURATION_UPDATE,
  PAYMENT_METHODS_FETCH_SUCCESS,
} from './types';

const paymentMethods = createReducer([], {
  [PAYMENT_METHODS_FETCH_SUCCESS]: (_, { payload }) => {
    const { paymentMethods } = payload;
    return paymentMethods;
  },
});

const isConfigurationListLoaded = createReducer(false, {
  [CONFIGURATIONS_FETCH]: () => false,
  [CONFIGURATIONS_FETCH_FAILURE]: () => false,
  [CONFIGURATIONS_FETCH_SUCCESS]: () => true,
});

const configurationList = createReducer([], {
  [CONFIGURATIONS_FETCH_SUCCESS]: (_, { payload }) => payload.configurations,
});

const configurationDetails = createReducer(
  {},
  {
    [CONFIGURATION_DETAIL_FETCH_SUCCESS]: (draft, { payload }) => {
      const { configurationDetail } = payload;
      draft[configurationDetail.id] = configurationDetail;
    },
    [CONFIGURATION_UPDATE_SUCCESS]: (draft, { payload }) => {
      const { configuration } = payload;
      draft[configuration.id] = configuration;
    },
  }
);

const paymentMethodCategories = createReducer([], {
  [PAYMENT_METHOD_CATEGORIES_FETCH_SUCCESS]: (draft, { payload }) =>
    payload.paymentMethodCategories,
});

const isOutletsLoaded = createReducer(false, {
  [OUTLET_FETCH]: () => false,
  [OUTLET_FETCH_FAILURE]: () => false,
  [OUTLET_FETCH_SUCCESS]: () => true,
});

const outlets = createReducer([], {
  [OUTLET_FETCH_SUCCESS]: (_, { payload }) => payload.outlets,
});

const paymentConfigurationError = createReducer(null, {
  [CONFIGURATION_UPDATE_FAILURE]: (draft, { payload }) => payload.response,
  [CREATE_CONFIGURATION_FAILURE]: (draft, { payload }) => payload.response,
  [CONFIGURATION_DETAIL_FETCH]: () => null,
  [CREATE_CONFIGURATION]: () => null,
  [CONFIGURATION_UPDATE]: () => null,
});

export default combineReducers({
  isConfigurationListLoaded,
  configurationList,
  configurationDetails,
  paymentMethods,
  paymentMethodCategories,
  isOutletsLoaded,
  outlets,
  paymentConfigurationError,
  ui,
});
